import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home, Stethoscope, LineChart, Users, User, Mic } from "lucide-react";
import { useApp } from "../../context/AppContext";

// The five permanent, always-labelled public tabs (per role, content differs at page level).
const TABS = [
  { to: "/", icon: Home, end: true, label: { English: "Today", हिंदी: "आज", Hinglish: "Aaj" } },
  { to: "/fasal-doctor", icon: Stethoscope, label: { English: "Doctor", हिंदी: "डॉक्टर", Hinglish: "Doctor" } },
  { to: "/market", icon: LineChart, label: { English: "Prices", हिंदी: "भाव", Hinglish: "Bhav" } },
  { to: "/resources", icon: Users, label: { English: "Saathi", हिंदी: "साथी", Hinglish: "Saathi" } },
  { to: "/profile", icon: User, label: { English: "Me", हिंदी: "मैं", Hinglish: "Main" } },
];

export default function MobileBottomNav() {
  const { language } = useApp();
  const navigate = useNavigate();
  const lbl = (t) => t[language] || t.English;
  const micLbl = { English: "Voice search", हिंदी: "आवाज़ से खोजें", Hinglish: "Aawaz se khojein" }[language] || "Voice search";

  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-[10000]" data-testid="bottom-nav">
      <div className="relative agro-glass border-t border-white/50 px-2 pb-[env(safe-area-inset-bottom)] rounded-t-[26px]">
        <div className="flex items-center justify-between h-[68px] px-1">
          {TABS.slice(0, 2).map((tb) => <Tab key={tb.to} tb={tb} lbl={lbl} />)}
          <div className="w-16 shrink-0" />
          {TABS.slice(2).map((tb) => <Tab key={tb.to} tb={tb} lbl={lbl} />)}
        </div>
        {/* center raised mic FAB */}
        <div className="absolute left-1/2 -translate-x-1/2 -top-6 flex flex-col items-center">
          <motion.button whileTap={{ scale: 0.9 }} onClick={() => navigate("/ai")} data-testid="bnav-voice"
            className="h-14 w-14 rounded-full bg-primary text-white flex items-center justify-center shadow-[0_8px_24px_rgba(23,63,30,0.4)] ring-4 ring-[#f4efe2]">
            <Mic className="h-6 w-6" />
          </motion.button>
          <span className="text-[10px] font-semibold text-primary mt-1">{micLbl}</span>
        </div>
      </div>
    </nav>
  );
}

function Tab({ tb, lbl }) {
  const Icon = tb.icon;
  return (
    <NavLink to={tb.to} end={tb.end} data-testid={`bnav-${tb.to === "/" ? "home" : tb.to.slice(1)}`}
      className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 flex-1 py-1 tap ${isActive ? "text-primary" : "text-[#6c7a67]"}`}>
      {({ isActive }) => (
        <>
          <Icon className="h-[22px] w-[22px]" strokeWidth={isActive ? 2.5 : 2} />
          <span className={`text-[10px] ${isActive ? "font-bold" : "font-medium"}`}>{lbl(tb.label)}</span>
        </>
      )}
    </NavLink>
  );
}
